import { render } from "./Strategic_relations.vue?vue&type=template&id=c9ea1738&scoped=true"
import script from "./Strategic_relations.vue?vue&type=script&lang=js"
export * from "./Strategic_relations.vue?vue&type=script&lang=js"

import "./Strategic_relations.vue?vue&type=style&index=0&id=c9ea1738&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ea1738"]])

export default __exports__